import React, { Component } from "react";
import PartnerTermsNeueHouseView from "./view";
import { getNeuehouse } from "../../requests/get-neuehouse";

class PartnerTermsNeueHouse extends Component {
  constructor(props) {
    super(props);

    this.reference = React.createRef();
  }

  componentDidMount() {
    getNeuehouse().then(
      (response) =>
        (this.reference.current.innerHTML = response.data.data.content)
    );
  }

  render() {
    return <PartnerTermsNeueHouseView reference={this.reference} />;
  }
}

export default PartnerTermsNeueHouse;
